import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable } from 'rxjs';
import { Pagination, Award } from '@shared/interfaces';
import { map } from 'rxjs/operators';

@Injectable()
export class AwardsService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  getAll(): Observable<Award[]>{
    return this.http.get<Pagination<Award>>(this.api.AWARDS())
      .pipe(map(item => item.items));
  }

  get(id: number): Observable<Award>{
    return this.http.get<Award>(this.api.AWARDS(id));
  }

}
